<template>
    <div style="height: 100%;" class="p-1">
        <div class="sa-ft-modern-clinical">
            <section class="sa-ft-section-container">
                <div class="sa-ft-form-card">
                    <div class="sa-ft-card-header">
                        <div class="sa-ft-section-icon">☕</div>
                        <h3>Sacc Sar Test</h3>

                    </div>
                    <div class="sa-ft-grid" style="gap:12px">
                        <div class="sa-ft-field flex-1 ">
                            <div class="sa-ft-icon-box">🏢</div>
                            <div class="sa-ft-inner-row">
                                <div class="sa-ft-inner-column flex-main">
                                    <label class="sa-ft-form-label">Codice
                                        Struttura</label>
                                    <select class="sa-ft-form-select" v-model="parameter.codiceStruttura">
                                        <option v-for="s, i in codiciStruttureOptions" :key="i"
                                            :value="s.codiceStruttura">
                                            {{ s.codiceStruttura }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="sa-ft-field flex-1 ">
                            <div class="sa-ft-icon-box">⚙️</div>
                            <div class="sa-ft-inner-row">
                                <div class="sa-ft-inner-column flex-main">
                                    <label class="sa-ft-form-label">Servizio</label>
                                    <select class="sa-ft-form-select" v-model="parameter.servizio">
                                        <option v-for="s, i in serviceOptions" :key="i" :value="s.value">
                                            {{ s.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">🆔</div>
                            <div class="sa-ft-inner-row">
                                <div class="sa-ft-inner-column flex-main">
                                    <label class="sa-ft-form-label">Nominativo</label>
                                    <input class="sa-ft-form-input" type="text">
                                </div>
                            </div>
                        </div>

                        <button class="mr-1 no-text rounded-circle sa-ft-floating-btn success" @click="onSendCall">
                            <i>🚀</i>
                        </button>


                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
// import axios from "axios";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../utility/UtilityMixin";
// import FlussiDettagliModalViewComponent from "./FlussiDettagliModalViewComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: {},
    data() {
        return {
            parameter: {
                codiceStruttura: null,
                servizio: null
            },

            serviceOptions: [
                { value: "/saccsarr/presaincarico/", text: "presaincarico" },
                { value: "/saccsarr/paziente/", text: "paziente" },
                { value: "/saccsarr/appuntamenti/", text: "appuntamenti" },
            ],
            jsonData: {},
            codiciStruttureOptions: [],
        };
    },
    computed: {
        formattedJsonData() {
            if (!this.jsonData || Object.keys(this.jsonData).length === 0) {
                return "";
            }
            try {
                return JSON.stringify(this.jsonData, null, 2);
            } catch (error) {
                return "Errore nella formattazione del JSON";
            }
        },

    },

    mounted() {
        this.loadSaccSarrStrutture();
    },
    methods: {
        loadSaccSarrStrutture() {
            this.loadDataResources("/saccsarr", null, this.loadSaccSarrStruttureSuccess, this.loadSaccSarrStruttureError);
        },
        loadSaccSarrStruttureSuccess(response) {
            this.codiciStruttureOptions = response.data.data.list;

        },
        loadSaccSarrStruttureError(error) {
            error;
        },
        onSubmit() {
            let me = this;
            if (me.identificativo !== null && me.identificativo !== "") {
                if (me.struttura !== null && me.struttura !== "") {
                    let path = me.path + me.struttura + "?identificativo=" + me.identificativo.toUpperCase();
                    this.loadDataResources(path, null, me.loadDataSuccess, me.loadDataError);
                } else {
                    me.jsonData = { esito: false, returnValue: 0, messaggio: "Campo Struttura non valido", data: "" };
                }
            } else {
                me.jsonData = { esito: false, returnValue: 0, messaggio: "Campo Identificativo non valido", data: "" };
            }
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data;
            me.$emit("afterLoadData");
            me.listKey++;
        },
        loadDataError(response) {
            let me = this;
            me.jsonData = response.response.data;
        },
        onSendCall() {
            console.log(this.parameter);


        },


        onReset() {
            let me = this;
            me.identificativo = null;
            me.struttura = null;
            me.jsonData = {};
        },
    },
};
</script>
